// @tenorlab/vue-dashboard-pro
// file: src/bundled-widgets/widget-credit-overview/meta.ts
import type { TWidgetMetaInfo } from '@tenorlab/vue-dashboard'
import { markRaw } from 'vue'
import { CreditCardIcon as ComponentIcon } from 'lucide-vue-next'

// Define the metadata object for the plugin
export const WidgetCreditOverviewMeta: TWidgetMetaInfo = {
  name: 'Credit Overview',
  categories: ['Widget'],
  icon: markRaw(ComponentIcon),
  noDuplicatedWidgets: true,
  description: 'Displays an overview of your credit germs and limits.',
  externalDependencies: [],
}
